import { Autocomplete } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const StyledAutocomplete = styled(Autocomplete)`
  &.MuiAutocomplete-root {
    min-width: 200px !important;
    max-width: 325px;

    ${variables.mediaQuery.lessThan('desktop')`
      min-width: unset !important;
      max-width: unset;
      width: 90%;
      `}
  }
`;
